import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-header">
            <div className="hero-logo-wrapper" data-aos="fade-up">
              <h2 className="hero-brand-name">MLblocks</h2>
              {/* <img 
                src="/brain_logo_white_final.svg" 
                alt="Neural Network Visualizer Logo" 
                className="hero-brain-logo"
              /> */}
            </div>
            <h1 className="hero-title" data-aos="fade-up" data-aos-delay="100">
              Build, Train, and Visualize Neural Networks in 3D
            </h1>
            <div className="hero-description-wrapper">
              <p className="hero-description" data-aos="fade-up" data-aos-delay="200">
                Create neural network architectures with our drag-and-drop model builder, train them with real-time monitoring, 
                and visualize training progress in stunning WebGPU-powered 3D. From CNN to Transformers, build any architecture with ease.
              </p>
              <div className="hero-buttons" data-aos="fade-up" data-aos-delay="400">
                <Link to="/signin" className="btn btn-primary">
                  <span className="btn-content">
                    Start Training
                    <span className="btn-arrow">→</span>
                  </span>
                </Link>
                <a href="#features" className="btn btn-secondary">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

